import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import DataAction from '../../data/actions';
import Utils from '../../utils';
import { defaultValue } from './InstallationContext';
import usePublicLink from '../PublicLink/usePublicLink';

var useInstallationBootstrap = function useInstallationBootstrap(setting, settingValue) {
  var _React$useState = React.useState(defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      fetchFlag = _React$useState4[0],
      toggleFetch = _React$useState4[1];

  var _usePublicLink = usePublicLink(),
      publicId = _usePublicLink.publicId;

  React.useEffect(function () {
    if (publicId) {
      return setState({
        value: true,
        loading: false,
        error: null
      });
    }

    var fetchData =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var action;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return DataAction.item({
                  dataType: 'microserviceSetting',
                  id: setting
                }).fetch();

              case 2:
                action = _context.sent;

                if (!action.failed) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", setState({
                  value: null,
                  loading: false,
                  error: {
                    title: 'Initialization error',
                    details: Utils.getPrettyError(action.payload)
                  }
                }));

              case 5:
                if (!(action.payload === null)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", setState({
                  value: null,
                  error: null,
                  loading: false
                }));

              case 9:
                return _context.abrupt("return", setState({
                  value: settingValue(action.payload),
                  error: null,
                  loading: false
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData();
  }, [fetchFlag, publicId]);
  return _objectSpread({}, state, {
    reset: function reset() {
      toggleFetch(function (v) {
        return !v;
      });
    }
  });
};

export default useInstallationBootstrap;